import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";
import type { UseRequestAdminDashboardMembersProps } from "./useRequestAdminDashboardMembers";

export type KeyAdminDashUsersProps = {
  id: number;
  filter?: UseRequestAdminDashboardMembersProps["filter"];
  search?: string;
  filter_by_is_admin?: UseRequestAdminDashboardMembersProps["filter_by_is_admin"];
};

export const keyAdminDashUsers: BaseKeyFunction<KeyAdminDashUsersProps> = ({
  id,
  search,
  filter,
  filter_by_is_admin,
}) => [
  "admin-dash-members",
  id.toString(),
  filter ?? "",
  filter_by_is_admin ?? "",
  search ?? "",
];
